import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icn-doc",
  "use": "icon-icn-doc-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icn-doc\"><g fill-rule=\"evenodd\" stroke=\"#8695a1\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\"><path d=\"M16.5 15.75h1.875a4.875 4.875 0 10-2.764-8.885 7.5 7.5 0 10-8.149 8.844\" /><path d=\"M12 14.25v9M15.75 19.5L12 23.25 8.25 19.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol